import waFetch from './wa-fetch';
import responseTextAs from './response-text-as';

const responseAsJson = responseTextAs(JSON.parse);

const defaultHeaders = {
  Accept: 'application/json',
  'Content-Type': 'application/json'
};

export default (normalizeResponse, normalizeError) =>
  async (url, method, requestBodyAsObject, options = {}) =>
  {
    const headers = { ...defaultHeaders, ...(options.headers || {}) };

    try
    {
      const response = await waFetch(url, {
        ...options,
        method,
        headers,
        body: requestBodyAsObject ? JSON.stringify(requestBodyAsObject) : null
      });
      const payload = await responseAsJson(response);

      return (typeof normalizeResponse === 'function')
        ? normalizeResponse(payload)
        : payload;
    }
    catch (error)
    {
      return (typeof normalizeError === 'function')
        ? normalizeError(error)
        : error;
    }
  };
